import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/badges';

const ListBadges = () => {
  const filter = {};
  const [type, setType] = useState('REWARD');

  if (type) {
    filter.$and = [
      { type },
    ];
  }

  return (
    <ListResource
    {...{
      // searchable: true,
      api,
      sort: { page: 1, location: 1 },
      filter,
      // actions: {
      //   fileImport: { url: '/api/site/badges/files' },
      // },
      cols: [
        { key: 'name', sortable: true, children: 'Name' },
        { key: 'type', sortable: true, children: 'Type' },
        {
          key: 'active',
          getter(v) {
            return (
              <FA icon={v ? faEye : faEyeSlash} />
            );
          },
        },
        { key: 'description' },
        { key: 'image' },
      ],
      ctrls: [
        <select
          className="custom-select"
          key={0}
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="">All</option>
          {['REWARD','REDEMPTION'].map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>,
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
  );
};

export default ListBadges;
